import React from 'react';
import { Switch, Route } from 'react-router-dom';

import { PATHS } from '../AppConstants';
import IntegrationLanding from './pages/IntegrationLanding';
import IntegrationDetail from './pages/IntegrationDetail';

const IntegrationApp = () => (
	<Switch>
		<Route exact path={PATHS.TRAVEL_INTEGRATION_LANDING}>
			<IntegrationLanding />
		</Route>
		<Route path={PATHS.TRAVEL_INTEGRATION_LANDING}>
			<IntegrationDetail />
		</Route>
	</Switch>
);
export default IntegrationApp;
